import { UserPlan } from '@symon-ai/wisepipe-user';
// TODO: WP-6128: remove UserPlan after 2.19.0 release
export const userInfoSchema = {
    $id: 'urn:wisepipe-common-auth:UserInfo',
    type: 'object',
    properties: {
        fullName: { type: 'string', minLength: 1 },
        email: { type: 'string', minLength: 1 },
        hash: { type: 'string', minLength: 1 },
        userPlan: { type: 'string', enum: Object.values(UserPlan) }
    }
};
//# sourceMappingURL=userInfo.js.map